<template>
  <ion-page>
    <ion-header>
      <HeaderWithBackButtonComponent title="退会ページ" :show-button="false"/>
    </ion-header>
    <ion-content>
      <p class="ion-text-center">退会専用ページです。</p>
      <p class="ion-text-left ion-margin-horizontal">
        メールアドレスとパスワードを入力しログインしてください。<br>
        退会すると、登録した会員情報、保有ポイントが全て削除されます。<br>
        一度削除すると、元に戻すことはできません。
      </p>

      <div class="ion-margin-horizontal">
        <p class="input-label">メールアドレス</p>
        <ion-item fill="outline" class="containers" style="margin-bottom: 5px" :class="{ 'border-danger': (errors && errors.email) }">
          <ion-input class="mail-addless-input" v-model="email" placeholder="メールアドレス"></ion-input>
        </ion-item>
        <ion-text color="danger" v-if="errors && errors.email">{{ errors.email }}</ion-text>
      </div>

      <div class="ion-margin-horizontal">
        <p class="input-label">パスワード</p>
        <PasswordInput v-model="password" placeholder="パスワード" :errors="errors ? errors.password : null" style="margin-bottom: 5px"/>
        <ion-text color="danger" v-if="errors && errors.password" >{{ errors.password }}</ion-text>
      </div>

      <ion-grid class="ion-margin-end">
        <ion-col>
          <ion-button class="primary-button" style="width: 100%" @click="login()" >ログイン</ion-button>
        </ion-col>
      </ion-grid>

      <p class="ion-text-center">
        パスワードは分からない方
      </p>
      <p class="ion-text-left ion-margin-horizontal">
        以下のリンクからパスワードを再設定できます。<br>
        ログインしてください。<br>
      </p>

      <div class="ion-text-center">
        <a class="ion-margin-vertical" style="color: blue; text-decoration: underline" @click="router.push({name: 'WebWithdrawalForgotPassword'})">パスワードを忘れた方</a>
      </div>
    </ion-content>
    <AccountLockModal v-show="isShowAccountLockModal" @close-account-lock-modal="closeAccountLockModal" />
  </ion-page>
</template>

<script setup lang="ts">
import {
  IonPage,
  IonButton,
  IonContent,
  IonInput,
  IonItem,
  IonText,
  loadingController,
  LoadingOptions, IonHeader
} from '@ionic/vue'
import PasswordInput from '../../components/PasswordInput.vue';
import AccountLockModal from '../../components/AccountLockModal.vue'
import { Device } from '@capacitor/device';
import StorageService from '../../utils/StorageService'
import request from '../../utils/Request'
import { useRouter } from 'vue-router';
import { useForm, useFormErrors, useField } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { ERR_ACCOUNT_IS_LOCKED } from '@/consts/error-message'
import HeaderWithBackButtonComponent from "@/components/HeaderWithBackButton.vue";

const router = useRouter()

const schema = yup.object({
  'email': yup.string()
      .required('メールアドレスをご入力ください')
      .email('メールアドレスが正しくありません'),
  'password': yup.string()
      .required('パスワードをご入力ください')
      .matches(/^[a-zA-Z0-9]{8,255}$/, 'パスワードが正しくありません')
})

const formLogin = useForm({
  validationSchema: schema
})

const { value: email } = useField<string>("email")
const { value: password } = useField<string>("password")

const errors = useFormErrors() as any;

const isShowAccountLockModal = ref<boolean>(false)

async function login() {
  const resp = await formLogin.validate();

  if (resp.valid) {
    const deviceInfo = await Device.getInfo()
    const data = {...formLogin.values, ...{
        app_id: import.meta.env.VITE_APP_ID,
        device_uuid: await StorageService.get('deviceUuid'),
        osVersion: deviceInfo.osVersion,
        os: deviceInfo.operatingSystem
      }}

    const loading = await createLoading('送信処理中...')
    await loading.present()
    request.post('/login', data).then((res) => {
      if (res.status) {
        router.push({
          name: 'WebWithdrawalCodeVerify',
          query: {
            email: formLogin.values.email,
            type: 'withdraw'
          }
        })
      }
    }).catch((err) => {
      if (err.response?.status == 422) {
        console.log(err.response.data.message)
        if (err.response.data.message === ERR_ACCOUNT_IS_LOCKED) {
          isShowAccountLockModal.value = true;
        } else {
          formLogin.setErrors(err.response.data.errors);
        }
      }
      // formLogin.setErrors({email: ['エラーが発生しました']})
    }).finally(() => {
      loading.dismiss()
    })
  }
}

function closeAccountLockModal() {
  isShowAccountLockModal.value = false
}

async function createLoading(msg: string, duration?: number, spinner: LoadingOptions["spinner"] = "crescent") {
  return await loadingController.create({
    message: msg,
    duration: duration,
    spinner: spinner,
  })
}
</script>